var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30636 3.28597C5.34411 1.2608 8.36808 0.810024 10.8449 1.9375L11.4036 0.725277C8.43362 -0.626689 4.80464 -0.0886776 2.3577 2.34316C-0.7859 5.46735 -0.7859 10.5327 2.3577 13.6569L3.30636 12.7141C0.686698 10.1106 0.686698 5.88946 3.30636 3.28597ZM12.793 3.28597C15.4127 5.88946 15.4127 10.1106 12.793 12.7141C10.7553 14.7392 7.7313 15.19 5.2545 14.0625L4.69581 15.2747C7.66576 16.6267 11.2947 16.0887 13.7417 13.6569C16.8853 10.5327 16.8853 5.46735 13.7417 2.34316L12.793 3.28597ZM7.37888 5.33337C7.37888 4.96518 7.67921 4.66671 8.04969 4.66671C8.42017 4.66671 8.7205 4.96518 8.7205 5.33337V7.33337H10.7329C11.1034 7.33337 11.4037 7.63185 11.4037 8.00004C11.4037 8.36823 11.1034 8.66671 10.7329 8.66671H8.7205V10.6667C8.7205 11.0349 8.42017 11.3334 8.04969 11.3334C7.67921 11.3334 7.37888 11.0349 7.37888 10.6667V8.66671H5.36646C4.99598 8.66671 4.69565 8.36823 4.69565 8.00004C4.69565 7.63185 4.99598 7.33337 5.36646 7.33337H7.37888V5.33337Z",
    fill: "#9B9BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.00eba8b1.svg";
export { ForwardRef as ReactComponent };